// components/Orders/OrderStatusBadge.js
import React from "react";

const OrderStatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    const configs = {
      submitted: { color: "warning", text: "Submitted", icon: "fas fa-clock" },
      processing: { color: "info", text: "Processing", icon: "fas fa-cog" },
      completed: { color: "success", text: "Completed", icon: "fas fa-check" },
      Cancelled: { color: "danger", text: "Cancelled", icon: "fas fa-times" },
      Delivered: { color: "success", text: "Delivered", icon: "fas fa-truck" },
      pending: { color: "warning", text: "Pending", icon: "fas fa-hourglass" },
      Ready: { color: "info", text: "Ready", icon: "fas fa-hourglass" },
      Received: { color: "info", text: "Received", icon: "fas fa-hourglass" },
      Picked: { color: "info", text: "Picked", icon: "fas fa-hourglass" },
    };
    return configs[status] || { color: "secondary", text: status, icon: "fas fa-question" };
  };

  const config = getStatusConfig(status);

  return (
    <span className={`badge bg-${config.color} d-flex align-items-center gap-1`} style={{ paddingTop: 4 }}>
      <i className={config.icon}></i>
      {config.text}
    </span>
  );
};

export default OrderStatusBadge;